<template>
  <div class="footer-outer">
    <img src="../assets/images/vx.png" class="footer-outer-img"/>
    <div class="footer-outer-scan">扫码更快捷</div>
    <div class="footer-outer-contact">联系我</div>
    <a href="https://beian.miit.gov.cn">
      <div class="footer-outer-comp">浙ICP备2021017414号</div>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style scoped>
  .footer-outer {
    position: relative;
    height: 31.25vw;
    background: #1B1B1B;
    border: 1px solid #979797;
  }

  .footer-outer-img {
    width: 11.72vw;
    height: 11.72vw;
    position: absolute;
    left: 50%;
    margin-left: -5.86vw;
    top: 7.917vw;
  }

  .footer-outer-scan {
    font-family: PingFangSC-Regular;
    font-size: 1.25vw;
    color: #FFFFFF;
    text-align: center;
    line-height: 1.25vw;
    margin-top: 20.9375vw;
  }

  .footer-outer-contact {
    font-family: PingFangSC-Regular;
    font-size: 1.25vw;
    color: #FFFFFF;
    text-align: center;
    line-height: 1.25vw;
    margin-top: 0.9375vw;
  }

  .footer-outer-comp {
    width: 22vw;
    font-family: PingFangSC-Regular;
    font-size: 0.729vw;
    color: #FFFFFF;
    text-align: center;
    position: absolute;
    left: 50%;
    margin-left: -11vw;
    bottom: 0.833vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue